export default "__VITE_ASSET__39b91ae0__"